import React, { useEffect, useRef } from "react";
import styles from "./dashboard.module.scss";
import Carousel from "react-elastic-carousel";
import Product from "../../components/product/Product";
import Title from "../../components/title/Title";

const SubRegDashboard = (props) => {
  const { subRegionData, selectedRegion } = props;
  const mySRCarousel = useRef(null);

  const setSubRegion = (item) => {
    props.setSubRegion(item)
    props.history.push("/dashboard/subregiondetail");
  }

  const showHideLeftSRArrow = () => {
    // document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "none";
    if (document.querySelector("#subRegionContainer .rec.rec-arrow-left")) {
      //document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "none";
      if (document.querySelector("#subRegionContainer .rec.rec-arrow-left").disabled) {
        document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "block";
      }
      else {
        // document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "none";
      }
    }
  }

  const showHideRightSRArrow = () => {
    //document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
    if (document.querySelector("#subRegionContainer .rec.rec-arrow-right")) {
      //document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
      if (document.querySelector("#subRegionContainer .rec.rec-arrow-right").disabled) {
        document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "block";
      }
      else {
        document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
      }
    }
  }

  const mySubRegionCarouselChange = (current, pagenum) => {
    showHideLeftSRArrow();
    showHideRightSRArrow();
  }


  const onClickSRScrollToStart = () => {
    document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
    mySRCarousel?.current?.goTo(0);
  }

  const onClickSRScrollToEnd = () => {/*Left Cust Arrow- which takes to dead end */
    document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "none";
    mySRCarousel?.current?.goTo(subRegionData.length);
  }

  useEffect(() => {
    document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "block";
    document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
    mySRCarousel?.current?.goTo(0);

  }, [selectedRegion]);

  useEffect(() => {
    document.querySelector("#subRegionContainer #subRegionScrollToEnd").style.display = "block";
    document.querySelector("#subRegionContainer #subRegionScrollToStart").style.display = "none";
    mySRCarousel?.current?.goTo(0);

  }, []);


  const subRegionBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2, itemsToScroll: 2 },
    { width: 850, itemsToShow: 3, itemsToScroll: 2 },
    { width: 1150, itemsToShow: 5, itemsToScroll: 4 },
    { width: 1450, itemsToShow: 6, itemsToScroll: 5 },
    { width: 1750, itemsToShow: 7, itemsToScroll: 6 }
  ]

  return (
    <div  className={`${styles.subregContainerWidth}`}>
      <div id="subRegionContainer" className={styles.subregionProductsContainer}>
        {<div className={styles.scrollEndParent}>
          <div id="subRegionScrollToEnd" className={`${styles.leftSRArrow} ${styles.buttonStyle} `} onClick={() => onClickSRScrollToEnd()}>{"❮"}</div>
        </div>}
        {
          <div className={styles.productBox}>

            <div className={`row no-gutters ${styles.customerLayoutBx} ${styles.customerList} ${styles.tilePaddingbottom} ${styles.tilePaddingtop}`}>
              <Title value="Sub-regions" count={subRegionData.length} />
              <Carousel ref={mySRCarousel}
                onChange={(currentItem, pageIndex) =>
                  mySubRegionCarouselChange(currentItem, pageIndex)}
                breakPoints={subRegionBreakPoints}>
                {subRegionData?.map((item, index) => {
                  return (
                    <Product
                      key={index}
                      product={item}
                      {...props}
                      type="subregion"
                      showDetail={setSubRegion}
                    />
                  );
                })}
              </Carousel>
            </div>

          </div>
        }
        {<div className={styles.scrollStartParent}>
          <div id="subRegionScrollToStart" className={`${styles.rightSRArrow} ${styles.buttonStyle} `} onClick={() => onClickSRScrollToStart()}>{"❯"}</div>
        </div>}
      </div>
    </div>

  )
}
export default SubRegDashboard;